module.exports = __webpack_public_path__ + "static/media/nexalyn-results-package.7020b0ee.png";